import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of, switchMap, filter, take } from 'rxjs';
import { FirebaseFirestoreService } from '../../services/firebase.firestore.service';
import { FirebaseAuthService } from '../../services/firebase.auth.service';

export function AuthGuard(): CanActivateFn {
  return () => { 
    const router: Router = inject(Router);
    const firebaseAuthService: FirebaseAuthService = inject(FirebaseAuthService);
  
    const user$ = firebaseAuthService.user$;
    return user$.pipe(
      switchMap((user) => {
        if (!user) {
          router.navigate(['/login']);
        }
        return of(!!user);
      })
    );
  }
}

export function HomeGuardService(): CanActivateFn {
  return () => {  
    const router: Router = inject(Router);
    const firebaseAuthService: FirebaseAuthService = inject(FirebaseAuthService);
    const firebaseFirestoreService: FirebaseFirestoreService = inject(FirebaseFirestoreService);

    // Wait for both user authentication and user profile to be resolved
    return firebaseAuthService.user$.pipe(
      switchMap((user) => {
        if (!user) {
          router.navigate(['/login']);
          return of(false);
        }
        
        // Wait for user profile to be loaded
        return firebaseFirestoreService.subscribeToUserProfile().pipe(
          filter((userProfile) => userProfile !== null), // Wait until userProfile is not null
          take(1), // Take only the first non-null value
          switchMap((userProfile) => {
            const isOnboardingComplete = userProfile?.onboardingCompleted;
            if (!isOnboardingComplete) {
              router.navigate(['/onboarding']);
              return of(false);
            }
            return of(true);
          })
        );
      })
    );
  }
}
